export default __webpack_public_path__ + "locales/pl/Notifications.json?hash=b408e929e5a01a3d92b130e24d43e15e";